/**
 * Компонент прогресс-бара для batch событий
 */
import React from 'react';
import { Progress, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { calculateProgress } from '../utils/eventFormatters';

const { Text } = Typography;

interface EventProgressBarProps {
  completed: number;
  total: number;
  showText?: boolean;
}

export const EventProgressBar: React.FC<EventProgressBarProps> = ({
  completed,
  total,
  showText = true,
}) => {
  const { t } = useTranslation('events');
  const progress = calculateProgress(completed, total);

  return (
    <div>
      <Progress percent={progress} status={progress === 100 ? 'success' : 'active'} />
      {showText && (
        <Text type="secondary">
          {t('progress.completedOf', { completed, total })}
        </Text>
      )}
    </div>
  );
};
